import "date-fns";
import React from "react";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
import Typography from "../typography";
// import { ITeam } from "../../types";
import {
  Card,
  Grid,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogContentText,
  // DialogActions,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  // Fab,
} from "@material-ui/core";

// import Link from "../link";
// import Button from "../button";
// import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import messages from "./PageViewTeam.intl";
import { ResultChip } from "../molecules/cards";
// import { ActionLink } from "../atoms";
// import SnackBar from "../snackbar";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       width: "100%",
//       maxWidth: 360,
//       backgroundColor: theme.palette.background.paper
//     },
//     inline: {
//       display: "inline"
//     },
//     margin: {
//       margin: theme.spacing(2)
//     },
//     textField: {
//       marginLeft: theme.spacing(1),
//       marginRight: theme.spacing(1),
//       width: 200
//     }
//   })
// );

const CardWrapper = styled(Card)(({ theme }: IStyledArguments) => ({
  background: theme.palette.background.paper,
  borderRadius: 16,
  border: `1px solid ${theme.palette.extra.borderColor}`,
  boxShadow: "0 1px 3px rgba(16, 21, 26, 0.06)",
  flexDirection: "column",
  display: "flex",
  transition: "box-shadow 0.2s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(16, 21, 26, 0.08)",
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: "16px",
  },
}));

const Header = styled("div")(({ theme }: IStyledArguments) => ({
  background: theme.palette.background.paper,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(2.5, 3),
  borderBottom: `1px solid ${theme.palette.extra.borderColor}`,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const Content = styled("div")(({ theme }: IStyledArguments) => ({
  background: "transparent",
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
  },
}));

const Title = styled("div")(({ theme }: IStyledArguments) => ({
  ...theme.typography.h6,
  marginBottom: 0,
  fontWeight: 700,
  color: theme.palette.primary.main,
}));

const Row = styled((props) => <Grid container {...props} />)({
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
});

const Section = styled("div")(({ theme }: IStyledArguments) => ({
  borderLeft: `3px solid ${theme.palette.primary.main}`,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  background: theme.palette.extra.backgroundGrey,
  borderRadius: "0 12px 12px 0",
}));

const SectionTitle = styled("div")(({ theme }: IStyledArguments) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  fontSize: "1.1rem",
  marginBottom: theme.spacing(1),
}));

// interface ITeamSummaryCardProps {
//   id: string;
//   data: any;
// }

const HistoricalCard = injectIntl<any>(
  ({ data, intl }) => {
    return (
      <>
        <CardWrapper>
          <Header>
            <Row>
              <Grid item xs={8}>
                {data && (
                  <Title>
                    {intl.formatMessage(messages.historicalData)}
                    {">"}
                  </Title>
                )}
              </Grid>
            </Row>
          </Header>
          <Content>
            {data &&
              data.map((season: any) => {
                return (
                  <ExpansionPanel>
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id={`panel-${season.id}`}
                      style={{ width: "100%" }}
                    >
                      <Typography.Subtitle1>
                        {season.league.name} - {season.league.startDate}
                      </Typography.Subtitle1>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        {season.matches &&
                          season.matches.map((match: any) => (
                            <Section>
                              <SectionTitle>
                                {match.isHomeTeamLocal
                                  ? `${match.homeTeam.name} vs ${match.awayTeam}`
                                  : `${match.awayTeam} vs ${match.homeTeam.name}`}
                                <Typography.Subtitle1>
                                  {`${match.location} - ${match.date} ${match.time}`}
                                </Typography.Subtitle1>
                                <Typography.Subtitle2>
                                  {match.isHomeTeamLocal
                                    ? `${match.score.home} vs ${match.score.away}`
                                    : `${match.score.away} vs ${match.score.home}`}
                                </Typography.Subtitle2>
                              </SectionTitle>
                              {match.isWon && (
                                <ResultChip $result="win">
                                  {intl.formatMessage(messages.won)}
                                </ResultChip>
                              )}
                              {match.isTie && (
                                <ResultChip $result="draw">
                                  {intl.formatMessage(messages.draw)}
                                </ResultChip>
                              )}
                              {match.isLost && (
                                <ResultChip $result="loss">
                                  {intl.formatMessage(messages.lost)}
                                </ResultChip>
                              )}
                            </Section>
                          ))}
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                );
              })}
          </Content>
        </CardWrapper>
      </>
    );
  }
);

export default HistoricalCard;
